/** Arabic for build 6B's entry forms: KPI targets, condition scores, funding envelopes, plan dates, test thresholds and the executive entries. Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  // KPI targets
  "KPI targets": "مستهدفات مؤشرات الأداء",
  "Proposed until someone agrees them.": "مقترحة حتى يعتمدها أحد.",
  "Target status": "حالة المستهدف",
  Proposed: "مقترح",
  "Basis — what the figure comes from": "الأساس — مصدر الرقم",
  "Why retire it?": "لماذا يُلغى؟",
  "NO TARGET": "بلا مستهدف",
  "FROM THE PACK": "من الحزمة",
  "No measures are installed for this site.": "لا توجد مؤشرات مثبّتة لهذا الموقع.",
  "{agreed} agreed, {proposed} proposed, {rest} from the pack or none.":
    "{agreed} معتمد، {proposed} مقترح، {rest} من الحزمة أو بلا مستهدف.",
  "Set a target, agree it, or retire it.": "حدّد مستهدفًا أو اعتمده أو ألغِه.",
  "Only an accountable manager or an administrator can change targets.":
    "لا يغيّر المستهدفات إلا المدير المسؤول أو مسؤول المنصة.",
  "Set by": "حدّده",
  "the pack's declaration": "ما أعلنته الحزمة",
  "Agree or change": "اعتماد أو تغيير",
  "{kpi}: target {value} saved as {status}.": "{kpi}: حُفظ المستهدف {value} بحالة {status}.",
  agreed: "معتمد",
  "Target for {kpi}": "المستهدف لـ {kpi}",
  "e.g. service agreement, clause 4.2": "مثل: اتفاقية الخدمة، البند 4.2",
  "The pack's target is {value}.": "مستهدف الحزمة {value}.",
  "Save target": "حفظ المستهدف",
  "{kpi}: target retired. The pack's target applies again.": "{kpi}: أُلغي المستهدف. يُطبّق مستهدف الحزمة مجددًا.",
  "{kpi}: target retired. The measure is now shown ungraded.": "{kpi}: أُلغي المستهدف. يُعرض المؤشر الآن دون تقييم.",
  "Retiring…": "جارٍ الإلغاء…",
  "Retire target": "إلغاء المستهدف",
  "No changes recorded for this target yet.": "لم تُسجَّل أي تغييرات على هذا المستهدف بعد.",
  "{when} — retired by {who}: {reason}": "{when} — ألغاه {who}: {reason}",
  "{when} — {who} set {value} ({status}): {basis}": "{when} — حدّد {who} القيمة {value} ({status}): {basis}",
  "Hide targets": "إخفاء المستهدفات",
  "See or set targets": "عرض المستهدفات أو تحديدها",
  "Agreed by {who}": "اعتمده {who}",
  "Agreed — {basis}": "معتمد — {basis}",

  // condition survey
  "Record a condition survey": "تسجيل مسح الحالة",
  "A measured score from 0 to 100.": "درجة مقيسة من 0 إلى 100.",
  "Find the asset": "ابحث عن الأصل",
  "Score (0–100)": "الدرجة (0–100)",
  "Survey date": "تاريخ المسح",
  "Basis — the survey or method": "الأساس — المسح أو الطريقة",
  "Pick the asset that was surveyed.": "اختر الأصل الذي جرى مسحه.",
  "{tag}: condition {score} saved. Health is now {health} ({band}).":
    "{tag}: حُفظت الحالة {score}. أصبحت السلامة الآن {health} ({band}).",
  "{tag}: condition {score} saved.": "{tag}: حُفظت الحالة {score}.",
  "{n} of {of} assets have a surveyed score. Health is worked out from it.":
    "لدى {n} من {of} أصل درجة مسح. تُحسب السلامة منها.",
  "Tag or name": "الرمز أو الاسم",
  "e.g. annual pump survey, visual and vibration": "مثل: المسح السنوي للمضخات، بصري واهتزازات",
  "Only an engineer or an administrator can record a condition score.":
    "لا يسجّل درجة الحالة إلا مهندس أو مسؤول المنصة.",
  Surveyed: "تاريخ المسح",
  "Entered by": "أدخله",

  // funding envelopes
  "Funding envelopes": "مخصصات التمويل",
  "Money available for each fiscal year.": "المال المتاح لكل سنة مالية.",
  "Envelope kind": "نوع المخصص",
  Currency: "العملة",
  "Basis — where the figure comes from": "الأساس — مصدر الرقم",
  Capex: "نفقات رأسمالية",
  Opex: "نفقات تشغيلية",
  "{kind} envelope for {year} saved: {amount}.": "حُفظ مخصص {kind} لعام {year}: {amount}.",
  "{kind} envelope for {year} removed.": "أُزيل مخصص {kind} لعام {year}.",
  "No envelope is set, so no year can be called funded or short.":
    "لم يُحدَّد أي مخصص، فلا يمكن وصف أي سنة بأنها ممولة أو ناقصة.",
  "not used: this site has its own": "غير مستخدم: لهذا الموقع مخصصه الخاص",
  "e.g. board-approved budget": "مثل: الميزانية المعتمدة من المجلس",
  "Save envelope": "حفظ المخصص",
  "Saving a year again replaces its figure.": "حفظ السنة مرة أخرى يستبدل رقمها.",
  "Only an administrator or an accountable manager can set envelopes.":
    "لا يحدّد المخصصات إلا مسؤول المنصة أو المدير المسؤول.",

  // maintenance plan dates
  "Change dates": "تغيير المواعيد",
  "{plan} on {tag}: saved.": "{plan} على {tag}: حُفظ.",
  "This plan runs on usage, so it has no interval in days.": "تعمل هذه الخطة حسب الاستخدام، فليس لها فاصل بالأيام.",
  "A new interval counts from the last time it was done.": "يُحسب الفاصل الجديد من آخر مرة نُفّذ فيها العمل.",
  "Save plan": "حفظ الخطة",

  // test thresholds
  "Thresholds and interval": "الحدود والفاصل الزمني",
  "Attention level": "مستوى التنبيه",
  "Fail level": "مستوى الإخفاق",
  "Threshold status": "حالة الحدود",
  "Saved as agreed.": "حُفظت بوصفها معتمدة.",
  "Saved as proposed.": "حُفظت بوصفها مقترحة.",
  "Agreed.": "معتمدة.",
  "Proposed — not yet confirmed against the certification basis.": "مقترحة — لم تُؤكَّد بعد مقابل أساس الاعتماد.",
  "Last changed by {who}, {when}.": "آخر تغيير بواسطة {who}، {when}.",
  "Only an accountable manager can confirm or change thresholds.": "لا يؤكد الحدود أو يغيّرها إلا المدير المسؤول.",
  "Change or confirm": "تغيير أو تأكيد",
  "lower is better": "الأقل أفضل",
  "higher is better": "الأعلى أفضل",
  "Attention level for {label}": "مستوى التنبيه لـ {label}",
  "Fail level for {label}": "مستوى الإخفاق لـ {label}",
  "e.g. GACAR Part 139, edition in force": "مثل: GACAR الجزء 139، الإصدار النافذ",
  "Save thresholds": "حفظ الحدود",

  // ACA checklist
  "Requirement status": "حالة المتطلب",
  "Not met": "غير مستوفى",
  "Evidence — the verifier and date, or where it is held": "الدليل — جهة التحقق والتاريخ، أو مكان حفظه",
  "Say what shows it is met: the verifier and date, or where the document is held.":
    "اذكر ما يثبت استيفاءه: جهة التحقق والتاريخ، أو مكان حفظ المستند.",
  "Keep the evidence under 500 characters.": "اجعل الدليل أقل من 500 حرف.",
  "Clear the entry": "مسح الإدخال",

  // benchmark peers
  "Peers and entered values": "المطارات النظيرة والقيم المُدخلة",
  "Add, change or remove any of them.": "أضف أيًا منها أو غيّره أو احذفه.",
  "ICAO code": "رمز ICAO",
  "Airport name": "اسم المطار",
  "Peer set": "مجموعة النظراء",
  Metric: "المؤشر",
  Values: "القيم",
  "Add the peer": "إضافة المطار النظير",
  "Entered values": "القيم المُدخلة",
  "No value entered yet. Add one from the published figure, with its source.":
    "لم تُدخل أي قيمة بعد. أضف قيمة من الرقم المنشور مع مصدره.",
  "A peer is named by its four-letter ICAO code, such as OMDB.": "يُعرَّف المطار النظير برمز ICAO المكوّن من أربعة أحرف، مثل OMDB.",
  "That is this airport, not a peer.": "هذا هو مطارنا، وليس مطارًا نظيرًا.",
  "That airport is already a peer.": "هذا المطار مُدرج بالفعل بين النظراء.",
  "Give the peer airport's name.": "اذكر اسم المطار النظير.",
  "Choose local, regional or global.": "اختر محليًا أو إقليميًا أو عالميًا.",
  "The value must be a number.": "يجب أن تكون القيمة رقمًا.",
  "The year must be between 1990 and this year.": "يجب أن تكون السنة بين 1990 والسنة الحالية.",
  "Say where the figure was published. A peer value is never estimated.":
    "اذكر أين نُشر الرقم. لا تُقدَّر قيمة المطار النظير أبدًا.",

  // improvement initiatives
  "Value a year": "القيمة في السنة",
  "Give the initiative a name.": "أعطِ المبادرة اسمًا.",
  "The value a year cannot be negative.": "لا يمكن أن تكون القيمة السنوية سالبة.",
  "The cost cannot be negative.": "لا يمكن أن تكون التكلفة سالبة.",
  "Delete this initiative?": "حذف هذه المبادرة؟",
  "Yes, delete it": "نعم، احذفها",

  // expansion options
  "Build time (months)": "مدة التنفيذ (بالأشهر)",
  "Passengers a year it adds": "الركاب الذين يضيفهم سنويًا",
  "Stands it adds": "المواقف التي يضيفها",
  "In the comparison": "ضمن المقارنة",
  "Compare it": "قارنه",
  "Leave it out": "استبعده",
  "Use starting figures": "استخدم الأرقام الابتدائية",
  "left out of the comparison": "مستبعد من المقارنة",
  "Enter this option's figures": "أدخل أرقام هذا الخيار",
  "The build time is a whole number of months from 1 to 240.": "مدة التنفيذ عدد صحيح من الأشهر بين 1 و240.",
  "The added capacity cannot be negative.": "لا يمكن أن تكون السعة المضافة سالبة.",
  "Stands are a whole number, zero or more.": "المواقف عدد صحيح، صفر أو أكثر.",
};

export default ar;
